var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "cvadjustments no-border", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-header",
        {
          staticClass:
            "border-bottom-0 headline-very-small text-uppercase font-weight-bold text-brand-dark pb-0 mb-3",
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _vm._v(
                        _vm._s(_vm.t.CV_Tool_CvInformation) +
                          " [" +
                          _vm._s(this.activeStep + " / " + this.lastStep) +
                          "]"
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("ArrowNavigation", {
                        on: {
                          click: function ($event) {
                            return _vm.changeSection($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-body",
        [
          this.activeStep === 1
            ? _c(
                "div",
                { staticClass: "text-muted pb-5" },
                [
                  _c("b-card-text", [
                    _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Intro_Short)),
                  ]),
                  _c("b-card-text", [
                    _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Intro)),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.activeStep === 1
            ? [
                _vm.competences !== undefined
                  ? _c("CvAdjustCompetences", {
                      attrs: {
                        items: _vm.competences,
                        competencesLink: _vm.competencesLink,
                        validCompetences: _vm.validSections,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.activeStep === 2
            ? [
                _vm.experiences !== undefined
                  ? _c("CvAdjustExperiences", {
                      attrs: {
                        items: _vm.experiences,
                        validExperiences: _vm.validSections,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.activeStep === 3
            ? [
                _c(
                  "section",
                  { staticClass: "cv-adjust-missing-data experience-items" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c("b-card-title", { staticClass: "h5" }, [
                          _vm._v(_vm._s(_vm.t.CV_Tool_Your_Information)),
                        ]),
                        _c(
                          "b-link",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.bottom",
                                value: {
                                  content: _vm.t.CV_Tool_Profile_Link_Tooltip,
                                  container: false,
                                },
                                expression:
                                  "{ content: t.CV_Tool_Profile_Link_Tooltip, container: false }",
                                modifiers: { bottom: true },
                              },
                            ],
                            staticClass:
                              "text-brand-medium font-weight-bold text-decoration-none",
                            style: { height: "fit-content" },
                            attrs: { href: _vm.profileLink },
                            on: { click: _vm.goToProfile },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.t.general_Add) +
                                " / " +
                                _vm._s(_vm.t.general_Edit)
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("b-card-text", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.t.CV_Tool_Adjust_Description)),
                    ]),
                    _vm._l(_vm.missingSections, function (section, key) {
                      return _c("ul", { key: key }, [
                        _c(
                          "li",
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: "exclamation-circle-fill",
                                variant: "danger",
                              },
                            }),
                            _c("span", { staticClass: "pl-2" }, [
                              _vm._v(_vm._s(section)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    _c("hr"),
                    _c(
                      "b-checkbox",
                      {
                        attrs: { size: "lg" },
                        on: { change: _vm.toggleHelpTexts },
                        model: {
                          value: _vm.addHelpTexts,
                          callback: function ($$v) {
                            _vm.addHelpTexts = $$v
                          },
                          expression: "addHelpTexts",
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.CV_Tool_Add_HelpText))]
                    ),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _c(
            "b-row",
            { staticClass: "text-center mt-4" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2",
                      attrs: { variant: "link" },
                      on: { click: _vm.clearSelection },
                    },
                    [_vm._v(_vm._s(_vm.t.CV_Tool_Cancel))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }